module.exports = __webpack_public_path__ + "static/media/student-cry.f846b0c3.png";